import React from 'react';

import type { EmptyStateScreen } from './EmptyStateEvents';
import TrackedEmptyState from './TrackedEmptyState';

type NoCrawlersSelectedProps = {
  screen: EmptyStateScreen;
  onSelectAllCrawlers: () => void;
};

function NoCrawlersSelected({ screen, onSelectAllCrawlers }: NoCrawlersSelectedProps) {
  return (
    <TrackedEmptyState
      screen={screen}
      state="filtered"
      variant="no_crawlers_selected"
      headline="No crawlers selected"
      body="No crawler is ticked, so there is nothing to show. Pick crawlers to see their activity."
      action={{
        id: 'select_all_crawlers',
        label: 'Select all crawlers',
        destination: 'crawler_filter',
        onClick: onSelectAllCrawlers,
      }}
    />
  );
}

export default NoCrawlersSelected;
